import { API_BASE } from './constants';

const searchCache = {};

/**
 * Search for stops, locations and tipps with the given input.
 *
 * @name searchLocations
 * @function
 * @param {string} input        The input string.
 * @param {object} fetchOptions Options for the fetch request.
 * @return {object[]} An array of stop objects.
 */
export default async (input, fetchOptions = {}) => {
	if (!input) {
		return [];
	}
	if (typeof searchCache[input] === 'undefined') {
		// eslint-disable-next-line no-param-reassign
		fetchOptions.cache = fetchOptions.cache || 'force-cache';

		searchCache[input] = fetch(
			`${API_BASE}?s=${encodeURIComponent(input)}`,
			fetchOptions,
		).then((response) => response.json());
	}
	return searchCache[input];
};
// .catch(() => alert('Verbindung zum Server fehlgeschlagen. Bitte versuchen Sie es erneut.'))
